import { ComboBoxControlDataAttributesProps, DataAttributesProps } from "@multiweb/reactComponents";
import { loadLocalizationIfNeeded } from "@multiweb/reactCore/i18n";
import { ControlUtils } from "UI/UI/UI/Controls/ControlUtils";
import { EditableControlConnector } from "../EditableControlConnector";
import { GenericControlConnectorAttrs } from "../GenericControlConnector";

/**
 * Umožňuje napojení combobox komponenty do původní aplikace.
 */
export class ComboBoxControlConnector extends EditableControlConnector {
    /**
     * Jméno reduxového enumu, který bude nahrán
     */
    private readonly _enumName: string;

    /**
     * Řetězec hodnot comboboxu oddělených středníkem, které nemají být zobrazeny v comboboxu
     */
    private readonly _hideValues?: string;

    /**
     * Lokalizační klíč pro placeholder comboboxu
     */
    private readonly _placeholderLocKey?: string;

    constructor(attrs: GenericControlConnectorAttrs, canRender: boolean = false) {
        super(attrs, canRender);

        this._enumName = ControlUtils.getDataAttr("enumname", this.element);
        this._hideValues = ControlUtils.getDataAttr("hidevalues", this.element);
        this._placeholderLocKey = this._getPlaceholderLocKey();

        this._render();
    }

    /**
     * @inheritDoc
     * @protected
     */
    protected override _getPropsFromDataAttributes(): DataAttributesProps & ComboBoxControlDataAttributesProps {
        return {
            ...super._getPropsFromDataAttributes(),
            enumName: this._enumName,
            hideValues: this._hideValues,
            placeholderLocKey: this._placeholderLocKey,
        };
    }

    /**
     * Získá z definice lokalizační klíč pro placeholder comboboxu. Vrací undefined, pokud není zadán.
     * @private
     */
    private _getPlaceholderLocKey(): string | undefined {
        const placeholderLocKey = ControlUtils.getDataAttr("placeholderlc", this.element);
        if (placeholderLocKey) {
            loadLocalizationIfNeeded(placeholderLocKey);
        }
        return placeholderLocKey;
    }

    /**
     * @inheritDoc
     */
    public override validate(): boolean {
        this.setValid();
        return super.validate();
    }
}
